import ToggleModal from './ToggleModal'

export default ToggleModal
